import { titleColor } from './common'
/** 当月订单前五 */
export default data => {
  const dataSource = [['date', 'amount']].concat(data.map(i => [i.x, i.y]))
  return {
    title: {
      text: '月销量趋势',
      textStyle: {
        color: titleColor,
        fontSize: 30,
        fontWeight: 'bold'
      },
      textAlign: 'left'
    },
    grid: {
      top: '18%',
      right: '10%',
      left: '14%',
      bottom: '15%'
    },
    textStyle: {
      color: '#fff',
      fontSize: 20,
      fontWeight: 'bold'
    },
    dataset: {
      source: dataSource
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    yAxis: {
      type: 'value',
      name: '总销售额',
      axisLabel: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      nameTextStyle: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#666'
        }
      }
    },
    xAxis: {
      type: 'time',
      name: '日期',
      nameTextStyle: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      axisLabel: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#333'
        }
      }
    },
    series: [
      {
        type: 'line',
        label: {
          show: true,
          fontSize: 20,
          fontWeight: 'bold'
        },
        encode: {
          y: 'amount',
          x: 'date'
        }
      }
    ]
  }
}
